import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { useUser } from '~/@biz_account/useUser/useUser'
import { MarketingNotificationsSettingsForm } from './MarketingNotificationsSettingsForm'

function MarketingNotificationsSettings() {
  const { user, reloadUser } = useUser()
  const marketingInitial = user
    ? user.profile?.gdpr?.marketingType !== 'refused'
    : false

  const { setNotification } = useLocalNotifications()

  function handleSuccess() {
    setNotification('info', 'Nastavenie emailovej komunikácie bolo uložené.')
    reloadUser()
  }

  if (!user) return null

  return (
    <MarketingNotificationsSettingsForm
      initialValues={{ isMarketingEnabled: marketingInitial }}
      onSuccess={handleSuccess}
    />
  )
}

export { MarketingNotificationsSettings }
